module.exports = __webpack_public_path__ + "assets_1789457014240/img/guide_ios.431fc979.png";